module.exports = __webpack_public_path__ + "img/cp-logo.d85d7dda.png";